const FORMULA_START = /^[=+\-@\t\r]/;
const LONE_DASH = "-";

function escapeCell(value) {
  const raw = value === null || value === undefined ? "" : String(value);
  const text = raw !== LONE_DASH && FORMULA_START.test(raw) ? `'${raw}` : raw;
  return /[",\r\n]/.test(text) ? `"${text.replace(/"/g, '""')}"` : text;
}

export function buildCsv(columns, rows) {
  const header = columns.map((column) => escapeCell(column.label)).join(",");
  const lines = rows.map((row) => columns.map((column) => escapeCell(row[column.key])).join(","));
  return [header, ...lines].join("\n");
}
